import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNeonContainer = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 233,
	height: 272,
	viewBox: "0 0 233 272",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.85069 80.4018L108.82 3.27768C113.049 0.140353 118.83 0.126938 123.074 3.24462L228.105 80.4036C231.182 82.6646 233 86.2555 233 90.0745V259.718C233 266.346 227.627 271.718 221 271.718H12C5.37258 271.718 0 266.346 0 259.718V90.0396C0 86.2402 1.79924 82.6653 4.85069 80.4018Z",
		fill: "#6C9CFA"
	})
});
export default SvgNeonContainer;
